import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-60" data-mp="26mmawj50yzj7">
      <div className="mx-auto w-full max-w-4xl" data-id="element-61" data-mp="22lso5t3bjqrw">
        <SectionHeading tone="light" eyebrow="La trasformazione" title={<>
              Da un odontoiatra che dubita prima di ogni riabilitazione… a un
              professionista che{' '}
              <span className="italic text-gold-dark" data-id="element-63" data-mp="2q9kcjv24vu9j">
                diagnostica con un sistema
              </span>
            </>} subtitle="Più di 2.400 ore di incertezza clinica ridotte." data-id="element-62" data-mp="22iy3c0ge83xy" />

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-64" data-mp="1evyaxaf38074">
          <div className="flex flex-col rounded-2xl border border-danger/20 bg-white p-5" data-id="element-65" data-mp="19wddj4fkfzwi">
            <div className="flex items-center gap-2" data-id="element-66" data-mp="175clk0t409i0">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-danger/10" data-id="element-67" data-mp="175vvau8lvrky">
                <XIcon className="h-4 w-4 text-danger" aria-hidden="true" data-id="element-68" data-mp="1c3xedf617qwf" />
              </span>
              <h3 className="text-[13px] font-extrabold uppercase tracking-[0.14em] text-danger" data-id="element-69" data-mp="y4649pimyunp">
                Prima
              </h3>
            </div>
            <ul className="mt-4 space-y-3" data-id="element-70" data-mp="of4mbtsj6373">
              {beforeItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-71" data-mp="t5l57tf4eh0u">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger/70" aria-hidden="true" data-id="element-72" data-mp="t760jl99e3zr" />
                  <span className="text-[14.5px] leading-snug text-ink/75" data-id="element-73" data-mp="jfa043jpa1sd">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-2xl border border-success/25 bg-white p-5 shadow-[0_18px_40px_-30px_rgba(31,122,90,0.6)]" data-id="element-74" data-mp="afmv77rriduk">
            <div className="flex items-center gap-2" data-id="element-75" data-mp="2c5u3s9eogefp">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-success/10" data-id="element-76" data-mp="27dsrwolf8pq7">
                <CheckIcon className="h-4 w-4 text-success" aria-hidden="true" data-id="element-77" data-mp="23bfpoa5vv9y6" />
              </span>
              <h3 className="text-[13px] font-extrabold uppercase tracking-[0.14em] text-success" data-id="element-78" data-mp="1yde7drga7enr">
                Con il Protocollo
              </h3>
            </div>
            <ul className="mt-4 space-y-3" data-id="element-79" data-mp="2v0snfni0x9l9">
              {afterItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-80" data-mp="2qzfev5njqsan">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" aria-hidden="true" data-id="element-81" data-mp="2m1dxqq9ol31t" />
                  <span className="text-[14.5px] font-medium leading-snug text-ink/85" data-id="element-82" data-mp="1ana4jmax3ixt">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-9 max-w-md" data-id="element-83" data-mp="vks6sbbr08k4">
          <CTAButton label="Voglio diagnosticare con un sistema" data-id="element-84" data-mp="vm3bqegxjmct" />
        </div>
      </div>
    </section>;
}